<script setup lang="ts">
import EbCalling0Icon from '@/components/Base/Icons/EbCalling0Icon.vue'
import EbCalling1Icon from '@/components/Base/Icons/EbCalling1Icon.vue'
import EbConferenceIcon from '@/components/Base/Icons/EbConferenceIcon.vue'
import EbFax2EmailIcon from '@/components/Base/Icons/EbFax2EmailIcon.vue'
import { useNetworkStore } from '@/stores/network/store'
import { onBeforeMount, onBeforeUnmount, onUnmounted, ref } from 'vue'

const icons = [
  EbCalling0Icon,
  EbCalling1Icon,
  EbConferenceIcon,
  EbFax2EmailIcon,
]

const visibleIconIndex = ref(0)

const iconSetterInterval = ref<any>()

onBeforeMount(() => {
  iconSetterInterval.value = setInterval(() => {
    if (visibleIconIndex.value >= icons.length - 1) {
      visibleIconIndex.value = 0
    } else {
      visibleIconIndex.value++
    }
  }, 1000)
  useNetworkStore().setShowFooter(false)
})

onBeforeUnmount(() => {
  clearInterval(iconSetterInterval.value)
})

onUnmounted(() => {
  setTimeout(() => {
    useNetworkStore().setShowFooter(true)
  }, 10)
})
</script>

<template>
  <div class="fixed flex flex-col justify-center items-center max-w-h">
    <div class="flex flex-col justify-center items-center">
      <div class="icons-wrapper">
        <component
          :is="icons[visibleIconIndex]"
          class="eb-icon loading-icon loading-icon__visible"
        ></component>
      </div>

      <h3 class="eb-heading" data-test="loading-text">
        {{ $t('global.loading') }}
      </h3>
    </div>
  </div>
</template>

<style scoped>
@reference "#tailwind";

.loading-icon {
  @apply text-primary-800 text-6xl mx-2;
  opacity: 0;
  margin: unset;
}

.loading-icon__visible {
  opacity: 1;
}

.icons-wrapper {
  width: 3.75rem;
  height: 3.75rem;
  overflow: hidden;
}

.max-w-h {
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
}
</style>
